/* eslint-disable arrow-body-style */
import React from 'react';
import classNames from 'classnames';
import SvgIcon from '@home/components/SvgIcon';
import './index.scss';

interface IProps {
  className?: string;
  style?: React.CSSProperties;
  onClick:  () => void;
}

export default function EditGpt(props: IProps) {
  const { className, style, onClick } = props || {};

  return (
    <>
      <span className={classNames('dbh-studio-edit', className)} style={style} onClick={onClick}>
        <SvgIcon className='dbh-studio-edit-icon' type="edit-icon" />
      </span>
    </>
  );
}
